import EditIcon from "@mui/icons-material/Edit";
import DeleteForeverIcon from "@mui/icons-material/DeleteForever";
import RequirementBox from "../../components/RequirementBox";
import { useTranslation } from "react-i18next";
import { Box, Divider, IconButton, Typography } from "@mui/material";
import { sortRequirementsByWeight } from "../../helpers/helpers";

export default function StandardQuestion({
  mData,
  handleEditQuestion,
  setSelectedModule,
  setToDeleteIdNameAndType,
}) {
  const { t } = useTranslation();

  const boxSxWeight = {
    display: "flex",
    flexDirection: "column",
  };

  const boxSxRequirement = {
    display: "flex",
    flexDirection: "column",
    width: "100%",
  };

  const emptyModule = {
    id: "",
    sortingNumber: 0,
    title: "",
  };

  return mData.questions.map((qData, qIndex) => (
    <>
      <Box
        key={qIndex}
        sx={{
          display: "flex",
          flexDirection: "row",
          justifyContent: "space-between",
          alignItems: "center",
          ml: 2.5,
          border: 0,
          borderBottom: 1,
          pb: 0.5,
          borderStyle: "dashed",
          mt: qIndex === 0 ? 0 : 2,
        }}
      >
        <Box
          sx={{
            display: "flex",
            flexDirection: "row",
            alignItems: "center",
          }}
        >
          <Typography
            sx={{
              fontFamily: "Inter",
              fontWeight: 500,
              fontStyle: "italic",
              pr: 1,
            }}
          >
            {t("question")} {qIndex + 1}
            {qData.title && `: ${qData.title}`}
          </Typography>
          <Typography sx={{ fontFamily: "Inter", ml: 0.5 }}>
            {qData.name}
          </Typography>
        </Box>
        <Box
          sx={{
            display: "flex",
            flexDirection: "row",
            alignItems: "center",
          }}
        >
          <IconButton
            sx={{ width: 30, height: 30 }}
            onClick={(e) => handleEditQuestion(e, qData)}
          >
            <EditIcon sx={{ width: 20, height: 20 }} />
          </IconButton>
          <IconButton
            sx={{
              width: 30,
              height: 30,
              mx: 1,
            }}
            onClick={(e) => {
              e.stopPropagation();
              setSelectedModule(emptyModule);
              setToDeleteIdNameAndType({
                id: qData.id,
                name: qData.title,
                type: "Question",
              });
            }}
          >
            <DeleteForeverIcon sx={{ width: 20, height: 20 }} />
          </IconButton>
        </Box>
      </Box>
      <Typography sx={{ fontFamily: "Inter", ml: 3, mt: 1 }}>
        {`${qData.text} (${t("source")}: ${
          qData.source ? qData.source : t("none")
        })`}
      </Typography>
      <Typography
        sx={{
          fontFamily: "Inter",
          fontStyle: "italic",
          textDecoration: "underline",
          ml: 3,
          mt: 1,
          pr: 1,
        }}
      >
        {t("reqs:")}
      </Typography>
      {qData.requirements.length === 0 && (
        <Typography
          sx={{
            alignSelf: "center",
            fontFamily: "Inter",
            fontSize: 14,
            mb: 1,
          }}
        >
          {t("noReqs")}
        </Typography>
      )}
      {[...(qData.requirements || [])]
        ?.sort(sortRequirementsByWeight)
        .map((reqData, rIndex) => (
          <Box
            key={rIndex}
            sx={{
              display: "flex",
              flexDirection: "row",
              ml: 7,
              py: 1,
              borderBottom: 1,
            }}
          >
            <RequirementBox
              boxSx={boxSxWeight}
              label={t("weight")}
              data={reqData.weight}
            />
            <Divider flexItem orientation="vertical" sx={{ mx: 2 }} />
            <RequirementBox
              boxSx={boxSxRequirement}
              label={t("req")}
              data={reqData.text}
            />
            <Divider flexItem orientation="vertical" sx={{ mx: 2 }} />
            <Box sx={boxSxRequirement}>
              {reqData.recommendations
                .sort((a, b) => a.level - b.level)
                .map((rec, recIndex) => (
                  <RequirementBox
                    key={rec.id} // immer key hinzufügen
                    boxSx={boxSxRequirement}
                    label={t(`recommendation${recIndex}`)}
                    data={rec.recommendationText} // ⚡ nur den Text rendern
                  />
                ))}
            </Box>
          </Box>
        ))}
    </>
  ));
}
